var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBackArrowLongTail = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39.05 16",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.47,9h0A1.75,1.75,0,0,0,2.73,9l7.54-6.59a1.26,1.26,0,0,0,0-2h0A1.75,1.75,0,0,0,8,.41L.47,7A1.26,1.26,0,0,0,.47,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.47,7h0a1.27,1.27,0,0,0,0,2L8,15.59a1.78,1.78,0,0,0,2.26,0h0a1.27,1.27,0,0,0,0-2L2.73,7A1.78,1.78,0,0,0,.47,7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.52,
    y: -11.01,
    width: 2.79,
    height: 38.28,
    rx: 1.39,
    transform: "translate(28.04 -11.79) rotate(90)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBackArrowLongTail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/back_arrow_long_tail.7446b7af.svg";
export { ForwardRef as ReactComponent };